import { alpha, type Theme } from '@mui/material';
import type { SystemStyleObject } from '@mui/system';

export const guaranteesClientStep2Styles = {
  documentsUploadStack: (theme: Theme) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
  }),
  documentsList: {
    width: '100%',
    overflowX: 'auto',
    WebkitOverflowScrolling: 'touch',
  },
  documentsHeader: (theme: Theme) => ({
    display: 'grid',
    gridTemplateColumns: { xs: 'minmax(280px, 1fr) 252px', sm: 'minmax(0, 1fr) 300px' },
    alignItems: 'center',
    minWidth: { xs: 560, sm: 0 },
    minHeight: 44,
    px: { xs: theme.spacing(2), sm: theme.spacing(3) },
    borderBottom: `1px solid ${theme.palette.border.subtle}`,
    backgroundColor: theme.palette.common.white,
  }),
  documentsHeaderCell: {
    color: 'text.primary',
    fontFamily: '"Nunito Sans", sans-serif',
    fontWeight: 800,
    fontSize: '14px',
    lineHeight: '20px',
    letterSpacing: 0,
    whiteSpace: 'nowrap',
    '&:last-of-type': {
      textAlign: 'right',
    },
  },
  documentRow:
    (isLast: boolean) =>
    (theme: Theme): SystemStyleObject<Theme> => ({
      display: 'grid',
      gridTemplateColumns: { xs: 'minmax(280px, 1fr) 252px', sm: 'minmax(0, 1fr) 300px' },
      alignItems: 'center',
      minWidth: { xs: 560, sm: 0 },
      minHeight: 72,
      px: { xs: theme.spacing(2), sm: theme.spacing(3) },
      borderBottom: isLast ? 'none' : `1px solid ${theme.palette.border.subtle}`,
      backgroundColor: theme.palette.common.white,
    }),
  documentNameWrap: {
    display: 'flex',
    alignItems: 'center',
    minWidth: 0,
    gap: 1,
    pr: 2,
  },
  documentIcon: {
    width: 18,
    height: 18,
    flexShrink: 0,
    color: 'text.secondary',
  },
  documentFileName: {
    minWidth: 0,
    color: 'text.primary',
    fontSize: '0.9375rem',
    lineHeight: '20px',
    fontWeight: 700,
    wordBreak: 'break-word',
    display: '-webkit-box',
    WebkitBoxOrient: 'vertical',
    WebkitLineClamp: 2,
    overflow: 'hidden',
  },
  documentActions: (theme: Theme) => ({
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    gap: theme.spacing(1),
    width: '100%',
  }),
  documentFileButton: (theme: Theme) => ({
    minHeight: 36,
    minWidth: 156,
    borderRadius: '100px',
    borderColor: theme.palette.border.subtle,
    color: theme.palette.text.primary,
    textTransform: 'none',
    fontSize: '0.9375rem',
    lineHeight: '20px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  }),
  documentDeleteButton: (theme: Theme) => ({
    width: 36,
    height: 36,
    borderRadius: '100px',
    flexShrink: 0,
    color: 'error.main',
    '&:hover': {
      backgroundColor: alpha(theme.palette.error.main, 0.08),
    },
  }),
  documentsUploadActions: (theme: Theme) => ({
    display: 'flex',
    justifyContent: 'flex-start',
    pt: theme.spacing(0.5),
  }),
  documentsAddButton: (theme: Theme) => ({
    minHeight: 36,
    minWidth: 176,
    borderRadius: '100px',
    borderColor: theme.palette.border.subtle,
    color: theme.palette.text.primary,
    textTransform: 'none',
    fontSize: '0.9375rem',
    lineHeight: '20px',
    fontWeight: 500,
    whiteSpace: 'nowrap',
    '&:hover': {
      borderColor: theme.palette.primary.main,
      backgroundColor: alpha(theme.palette.primary.main, 0.04),
    },
  }),
} as const;
